// extracted by mini-css-extract-plugin
export default {"title":"_challenges_title__EFmUT","chip":"_challenges_chip__FCRR0","footer":"_challenges_footer__wVbc9","exportXLS":"_challenges_exportXLS__IpjMG"};